export const APP_ID = 'things';
export const ROOT = `/admin/${APP_ID}`;
